import type { OrgId } from "@ctrl/controller-rpc";

import type { UseProfile } from "@/composables/useProfile";

/**
 * The Assistant can use integrations from every organization in the profile.
 * Other agents keep the editor's workspace-scoped fallback.
 */
export function getAgentIntegrationOrganizationIds(
  profile: UseProfile,
  isAssistantAgent: boolean
): OrgId[] | undefined {
  if (!isAssistantAgent) return undefined;

  const ids = new Set<OrgId>();
  const personalOrgId = profile.user.personal.organizationId;
  if (personalOrgId) ids.add(personalOrgId);
  for (const organization of profile.organizations) {
    ids.add(organization.id);
  }
  return Array.from(ids);
}
